import { Chip } from '@billda/design-system';

type GangRole = 'leader' | 'member';

interface GangRoleBadgeProps {
  role: GangRole;
  size?: 'sm' | 'md';
  color?:
    | 'default'
    | 'primary'
    | 'secondary'
    | 'success'
    | 'info'
    | 'warning'
    | 'error';
}

const roleLabelMap: Record<GangRole, string> = {
  leader: 'Leader',
  member: 'Member',
};

export const GangRoleBadge = ({
  role,
  size = 'sm',
  color,
}: GangRoleBadgeProps) => {
  const computedColor = color ?? (role === 'leader' ? 'primary' : 'default');

  return (
    <Chip
      label={roleLabelMap[role]}
      size={size}
      color={computedColor}
      variant={role === 'leader' ? 'filled' : 'outlined'}
    />
  );
};
